import { Button } from "@material-tailwind/react";
import React from "react";
import AboutTextArea from "./AboutTextArea";
import "./fonts.css";
export default function About() {
  return (
    <div className="xl:max-w-inner md:max-w-5xl mx-auto mt-12 mb-16 px-2">
      <div className="grid md:grid-cols-2 grid-cols-1">
        <div className="col-span-1 flex flex-col gap-9 justify-center mr-4">
          <h2 className="text-2xl md:text-4xl flex items-end gap-2">
            <img
              src="/hat-color.png"
              alt="hat"
              className="w-[40px] md:w-[60px] h-[40px] md:h-[58px] "
            />
            <span>About Anon Detect</span>
          </h2>
          <div className="flex flex-col gap-6 md:gap-10">
            <p className="leading-8 md:leading-10">
              Welcome to Anon Detect, your ultimate destination for a seamless
              blend of free and premium resources. Immerse yourself in our
              diverse array of content, spanning e-learning insights,
              captivating e-books, cutting-edge software reviews, exclusive
              Netflix mod APKs, and visually stunning wallpapers. Whether you're
              a knowledge enthusiast, a tech connoisseur, or simply seeking a
              touch of aesthetic inspiration, Anon Detect has you covered. Our
              commitment to providing both free and premium content ensures that
              everyone can access valuable resources, while our premium
              offerings unlock a world of exclusive benefits.
            </p>
            <p className="leading-8 md:leading-10">
            Join our community
              and embark on a journey where learning, entertainment, and
              innovation converge. Explore, engage, and elevate your online
              experience with Anon Detect.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <p className="text-blue-700">Join with us</p>
            <div className="flex gap-2">
              <img
                src="/about/fb.svg"
                alt="facebook"
                className="w-6 h-6 cursor-pointer"
              />
              <div className="p-[4px] border rounded-full border-gray-800 cursor-pointer">
                <img src="/about/insta.svg" alt="instagram" />
              </div>
              <img
                src="/about/linkdin.svg"
                alt="linkedin"
                className="w-6 h-6 cursor-pointer"
              />
            </div>
          </div>
          <div className="w-full flex">
            <Button className="bg-primary rounded-full px-14 py-3">
              See More
            </Button>
          </div>
        </div>
        <div className="flex items-center justify-center h-full">
          <div className="col-span-1  xl:w-[668px] w-[268px] xl:h-[668px] h-[368px] mt-10 md:mt-0">
            <img src="/owl2.png" alt="person" />
          </div>
        </div>
      </div>
      <AboutTextArea />
    </div>
  );
}
